import React from "react";
import cx from "classnames";
import styles from "./InfoTooltip.module.scss";
import infoIcon from "images/ciamInfo.svg";

interface InfoTooltipProps {
  children: React.ReactNode;
  className?: string;
  iconClassName?: string;
}

export const InfoErrorTooltip: React.FC<InfoTooltipProps> = ({
  className,
  iconClassName,
  children,
}) => {
  const [isVisible, setVisible] = React.useState(false);
  const toggleVisibility = (e: React.MouseEvent) => {
    setVisible(!isVisible);
    e.preventDefault();
  };

  return (
    <div className={styles.container}>
      <div
        className={cx(
          [styles.tooltipContainerNew, styles.tooltipPositionTopnew, className],
          {
            [styles.tooltipVisible]: isVisible,
          }
        )}
      >
        <div className={styles.contentContainer}>
          <div className={styles.contentNew}>{children}</div>
        </div>
      </div>
      <div>
        <button
          onClick={toggleVisibility}
          className={styles.buttonIcon}
          type="button"
        >
          <img src={infoIcon} alt="More info" />
        </button>
      </div>
    </div>
  );
};
